import { apiRequest } from './client';
import type { MedCreate, MedHistoryEntry, MedOut, MedStop, MedUpdate } from './types';

export async function listMeds(includeArchived = false): Promise<MedOut[]> {
  return apiRequest<MedOut[]>('/meds', {
    query: { include_archived: includeArchived },
  });
}

export async function createMed(payload: MedCreate): Promise<MedOut> {
  return apiRequest<MedOut>('/meds', { method: 'POST', body: payload });
}

export async function updateMed(id: number, payload: MedUpdate): Promise<MedOut> {
  return apiRequest<MedOut>(`/meds/${id}`, { method: 'PATCH', body: payload });
}

export async function stopMed(id: number, payload: MedStop): Promise<MedOut> {
  return apiRequest<MedOut>(`/meds/${id}/stop`, { method: 'POST', body: payload });
}

export async function resumeMed(id: number): Promise<MedOut> {
  return apiRequest<MedOut>(`/meds/${id}/resume`, { method: 'POST' });
}

export async function getMedHistory(id: number): Promise<MedHistoryEntry[]> {
  return apiRequest<MedHistoryEntry[]>(`/meds/${id}/history`);
}
